import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Resultnde() {
  return (
    <section className="result_nde p-100 text_nde">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>The Results</h2>
            <p>
              The updated website and web portals of NDE Offshore were much
              better in terms of loading speed and code efficiency. Furthermore,
              the upgrade removed all the bugs and lags and added e a completely
              new feel and user experience to the website.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="result_nde_img">
              <StaticImage
                src="../../../images/case-studies/nde/results.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={678}
                height={651}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultnde;
